module.exports = __webpack_public_path__ + "static/media/sepp_Herberger.77e9bd6b.png";